import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_HOST;

export const adminService = {
  async getSecurityCompliance() {
    const response = await axios.get(
      `${API_BASE_URL}/v1/admin/security/compliance`,
    );
    return response?.data?.data;
  },
};
